__turbopack_context__.v({
  "absolute": "LoDt-a_absolute",
  "always": "LoDt-a_always",
  "bar": "LoDt-a_bar",
  "barActions": "LoDt-a_barActions",
  "barInner": "LoDt-a_barInner",
  "chip": "LoDt-a_chip",
  "chipFace": "LoDt-a_chipFace",
  "description": "LoDt-a_description",
  "face": "LoDt-a_face",
  "iconButton": "LoDt-a_iconButton",
  "layer": "LoDt-a_layer",
  "list": "LoDt-a_list",
  "message": "LoDt-a_message",
  "panel": "LoDt-a_panel",
  "panelActions": "LoDt-a_panelActions",
  "panelHead": "LoDt-a_panelHead",
  "policy": "LoDt-a_policy",
  "row": "LoDt-a_row",
  "rowHint": "LoDt-a_rowHint",
  "rowLabel": "LoDt-a_rowLabel",
  "rowText": "LoDt-a_rowText",
  "save": "LoDt-a_save",
  "srOnly": "LoDt-a_srOnly",
  "surface": "LoDt-a_surface",
  "title": "LoDt-a_title",
});
